"use client"

import { CLOUDINARY_CLOUD } from "@/lib/cloudinary";
import { Faq1 } from "@/components/faq-1"
import { Footer7 } from "@/components/footer"
import { HeroNavVideoForm } from "@/components/hero-nav-video-form"
import { PropietariosForm } from "@/components/propietarios-form"
import { Feature61 } from "@/components/feature-61"
import { Cta14 } from "@/components/cta-full-width"
import { PortfolioCards } from "@/components/feature-cards"
import { Testimonial24 } from "@/components/testimonial-24"

export default function PropietariosPage() {
  const cardItems = [
    {
      icon: true,
      image: `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/icons/team_5064984_zfjblb.png`,
      title: "Equipo experto",
      description: "Nuestros agentes cuentan con herramientas y conocimientos específicos para ciertas zonas y tipos de propiedades.",
      link: '#'
    },
    {
      icon: true,
      image:`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/icons/team_5064984_zfjblb.png`,
      title: "Estrategia de marketing",
      description: "Publicamos la propiedad en los portales más populares optimizando el anuncio para captar la mayor cantidad de compradores calificados.",
      link: '#'
    },
    {
      icon: true,
      image:`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/icons/target_3234841_a4ws39.png`,
      title: "Departamento legal",
      description: "Nuestro equipo de abogados se encargará del aspecto legal durante todo el proceso, tanto para compra como para alquiler.",
      link: '#'
    },
    {
      icon: true,
      image: `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/icons/justice-scale_8303453_xmg2xd.png`,
      title: "Cartera de compradores",
      description: "Contamos con una amplia red de clientes y contactos que fuimos cultivando durante los años en el sector inmobiliario.",
      link: '#'
    },
    {
      icon: true,
      image:`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/icons/file_1346828_jmphqk.png`,
      title: "Visuales",
      description: "Fotografía, vídeo y drone profesional distribuídos en las plataformas de pisos y redes sociales más populares en distintos formatos.",
      link: '#'
    },
    {
      icon: true,
      image:`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/icons/diamond_2036193_pkuufk.png`,
      title: "Plataforma",
      description: "Nuestro sitio cuenta con un buscador en tiempo real, herramientas de geolocalización, vídeo marketing y más.",
      link: '#'
    }
  ]
 
  return (
    <>
      <div id="propietarios-form">
        <HeroNavVideoForm
          videoUrl={`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/video/upload/q_auto/f_auto/v1704039442/person/website/blazco_ryca73.mp4`}
          poster={`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/website/blazco-poster_mlb8l4.jpg`}
          title="Encontramos a la persona ideal para comprar o alquilar tu propiedad"
          description="Trabajamos de manera personal, como si fuéramos familia, para encontrar a ese alguien que pueda llamar hogar a tu propiedad. Tu no te preocupes por nada más que por cerrar el trato y recibir tus ingresos."
        >
          <PropietariosForm transparent={true} hideImage={true} />
        </HeroNavVideoForm>
      </div>
      <PortfolioCards 
        items={cardItems} 
        colorMode={false}
        uptitle="Person Inmobiliaria"
        title="Un equipo a tu servicio"
        backgroundColor="#EFEFEF"
      />
      <Faq1 
        uptitle="Person inmobiliaria"
        title="Preguntas frecuentes"
        items={[
          {
            id: "faq-1",
            question: "1. Valoración del inmueble",
            answer:
              "Valoramos el inmueble con herramientas actualizadas para definir su posible enfoque de alquiler o venta, en busca de la mayor rentabilidad posible."
          },
          {
            id: "faq-2",
            question: "2. Visuales y estrategias de marketing",
            answer:
              "Realizamos un estudio de fotografía, preparamos un Tour 3D y diseñamos una estrategia de marketing para conseguir un posicionamiento premium del inmueble.",
          },
          {
            id: "faq-3",
            question: "3. Publicación y difusión",
            answer:
              "Publicamos de forma destacada la vivienda en los principales portales inmobiliarios y nos ponemos en contacto con potenciales clientes interesados de nuestra base de datos.",
          },
          {
            id: "faq-4",
            question: "4. Visitas y filtración",
            answer:
              "Mostramos la propiedad a todos los potenciales compradores, ayudándolos y calificándolos durante todo el proceso.",
          },
          {
            id: "faq-5",
            question: "5. Asesoramiento legal",
            answer:
              "Ayudamos a ambas partes a navegar todos los aspectos legales de la operación usando nuestro conocimiento y experiencia en la industria.",
          }
        ]}
      />
      <Cta14
        title="¿Tienes alguna pregunta?"
        text="¿Tienes dudas? ¿Te gustaría resolverlas? ¡Es normal! Estás a punto de dar un paso gigantesco, poniendo tu vivienda en alquiler o a la venta. ¡Pocas cosas más importantes hay!"
        ctaText="¿Hablamos?"
        ctaHref="#propietarios-form"
        backgroundImage={`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/website_new/Person_2025_203_edit_a2y9qn.jpg`}
        backgroundColor="#EFEFEF"
        titleColor="#FFFFFF"
        textColor="#FFFFFF"
        buttonBackgroundColor="#FFFFFF"
        buttonTextColor="#000000"
        overlay={true}
      />
      <Testimonial24 backgroundColor="#EFEFEF" />
      <Feature61 
        imagePosition="right" 
        image={`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/person/website/Person_Febrero_203_i5nkss_1_qxbcbt.jpg`}
        title="Nuestra historia"
        description={
          <>
            <p className="text-sm leading-6 text-black">
            Somos una empresa fundada por 3 socios con más de 10 años de experiencia en el sector del ocio, la hostelería y los inmuebles. Cada uno de nosotros ha tenido por separado experiencias profesionales en diferentes ámbitos, que nos han llevado a entender que había algo que no se estaba haciendo bien en el mercado de los inmuebles. Este mundo va tan acelerado que no se trata a los clientes como personas, sino como números a los que vender rápido. Por eso creamos este proyecto.
            </p>
          </>
        }
        showButton={true}
        buttonText="¿Hablamos?"
        buttonHref="#propietarios-form"
      />
      <Footer7 />
    </>
  )
}

